// extracted by mini-css-extract-plugin
export default {"select-input-element":"SelectInput_select-input-element__TM9YA"};